import React from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";
import { LocationActivityTable } from "../../components/LocationActivityComponents/LocationActivityTable";

import "./styles.scss";

type ILocationActivityPageProps = RouteComponentProps<any>;

export const LocationActivityPage: React.FunctionComponent<
  ILocationActivityPageProps
> = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`locationActivityPage.${key}`);

  return (
    <div className="location-activity-page right-content">
      <div className="top-title-bar flex-grid">
        <PageTitle text={t("location_activity")} />
        <div className="line"></div>
      </div>
      <LocationActivityTable />
    </div>
  );
};
